import { StyleSheet } from "@react-pdf/renderer";

const INK = "#1C1A17";
const MUTED = "#5C574F";
const HINT = "#9B958C";
const GOLD = "#A58450";
const RULE = "#1C1A17";
const RULE_SOFT = "#E5E1DB";
const TABLE_HEAD_BG = "#1C1A17";
const TABLE_ROW_ALT = "#FAFAF8";
const PAGE_BG = "#FFFFFF";

export const styles = StyleSheet.create({
    page: {
        backgroundColor: PAGE_BG,
        color: INK,
        paddingTop: 56,
        paddingBottom: 70,
        paddingHorizontal: 56,
        fontFamily: "Lato",
        fontSize: 10.5,
        lineHeight: 1.5,
    },
    headRule: {
        height: 1,
        backgroundColor: RULE,
        marginBottom: 28,
    },
    coverInner: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        paddingBottom: 110,
    },
    coverTitle: {
        fontFamily: "Oswald-Bold",
        fontSize: 26,
        color: INK,
        textTransform: "uppercase",
        letterSpacing: 1,
        textAlign: "center",
    },
    coverSubtitle: {
        marginTop: 12,
        fontFamily: "Lato",
        fontSize: 14,
        color: GOLD,
        textAlign: "center",
        maxWidth: 480,
    },
    coverDivider: {
        marginTop: 26,
        marginBottom: 34,
        width: 110,
        height: 2,
        backgroundColor: INK,
    },
    coverMetaPrimary: {
        fontFamily: "Lato",
        fontSize: 11.5,
        color: "#3F3A33",
        textAlign: "center",
    },
    coverMeta: {
        fontFamily: "Lato",
        fontSize: 11.5,
        color: HINT,
        textAlign: "center",
        marginTop: 4,
    },
    sectionTitle: {
        fontFamily: "Oswald-Bold",
        fontSize: 18,
        color: INK,
        textTransform: "uppercase",
        letterSpacing: 0.6,
        marginBottom: 6,
    },
    sectionRule: {
        height: 1,
        backgroundColor: INK,
        marginBottom: 14,
    },
    h2: {
        fontFamily: "Lato-Bold",
        fontSize: 12.5,
        color: INK,
        marginTop: 14,
        marginBottom: 6,
    },
    h3: {
        fontFamily: "Lato-Bold",
        fontSize: 11,
        color: INK,
        marginTop: 10,
        marginBottom: 4,
    },
    paragraph: {
        fontFamily: "Lato",
        fontSize: 10.5,
        color: INK,
        marginBottom: 8,
        lineHeight: 1.55,
    },
    quoteBlock: {
        fontFamily: "Lato",
        fontSize: 10.5,
        color: INK,
        marginBottom: 8,
        lineHeight: 1.55,
        fontStyle: "italic",
        paddingLeft: 10,
        borderLeftWidth: 2,
        borderLeftColor: RULE_SOFT,
    },
    muted: {
        color: MUTED,
    },
    bullet: {
        flexDirection: "row",
        marginBottom: 5,
    },
    bulletDot: {
        width: 10,
        marginTop: 2,
        fontSize: 10,
        color: INK,
    },
    bulletText: {
        flex: 1,
        fontSize: 10.5,
        color: INK,
        lineHeight: 1.55,
    },
    // Source Index entries: number gutter + title row, URL on its own line
    // below the row (sibling, not nested beside the number — nested stacked
    // Texts in a flex column overlap in react-pdf).
    sourceEntry: {
        marginBottom: 6,
    },
    sourceRow: {
        flexDirection: "row",
    },
    sourceNum: {
        width: 30,
        fontSize: 10,
        color: MUTED,
        lineHeight: 1.45,
    },
    sourceTitle: {
        flex: 1,
        fontSize: 10,
        color: INK,
        lineHeight: 1.45,
    },
    sourceUrl: {
        marginLeft: 30,
        fontSize: 8.5,
        color: MUTED,
        lineHeight: 1.4,
    },
    proseBlock: {
        fontSize: 10.5,
        color: INK,
        lineHeight: 1.55,
    },
    tocRow: {
        flexDirection: "row",
        alignItems: "flex-end",
        marginBottom: 10,
    },
    tocLabel: {
        fontSize: 12,
        color: INK,
        fontFamily: "Lato-Bold",
    },
    tocFill: {
        flex: 1,
        borderBottomWidth: 0.5,
        borderBottomColor: RULE_SOFT,
        marginHorizontal: 6,
        marginBottom: 2,
    },
    namedItem: {
        display: "flex",
        flexDirection: "column",
        marginBottom: 10,
    },
    namedItemTitle: {
        fontFamily: "Lato-Bold",
        fontSize: 11,
        color: INK,
        marginBottom: 2,
    },
    namedItemBody: {
        fontSize: 10.5,
        color: INK,
        lineHeight: 1.55,
    },
    tableHead: {
        flexDirection: "row",
        backgroundColor: TABLE_HEAD_BG,
        marginTop: 6,
        borderWidth: 0.5,
        borderColor: RULE_SOFT,
    },
    tableHeadCell: {
        paddingHorizontal: 10,
        paddingVertical: 7,
        color: "#FFF",
        fontFamily: "Lato-Bold",
        fontSize: 10,
        textTransform: "uppercase",
        letterSpacing: 0.4,
    },
    tableRow: {
        flexDirection: "row",
        borderLeftWidth: 0.5,
        borderRightWidth: 0.5,
        borderBottomWidth: 0.5,
        borderColor: RULE_SOFT,
    },
    tableRowLast: {
        marginBottom: 12,
    },
    tableRowAlt: {
        backgroundColor: TABLE_ROW_ALT,
    },
    tableCell: {
        paddingHorizontal: 10,
        paddingVertical: 7,
        fontSize: 10.5,
        color: INK,
    },
    tableLabelCell: {
        width: 160,
        fontFamily: "Lato-Bold",
        color: MUTED,
    },
    objectionBlock: {
        display: "flex",
        flexDirection: "column",
        marginBottom: 14,
    },
    objectionQuote: {
        fontFamily: "Lato",
        fontSize: 10.5,
        color: INK,
        fontStyle: "italic",
        marginBottom: 4,
    },
    objectionResponseLabel: {
        fontFamily: "Lato-Bold",
        fontSize: 9.5,
        color: MUTED,
        textTransform: "uppercase",
        letterSpacing: 0.4,
        marginTop: 2,
        marginBottom: 3,
    },
    objectionResponseBody: {
        fontSize: 10.5,
        color: INK,
        lineHeight: 1.55,
    },
    footer: {
        position: "absolute",
        bottom: 30,
        left: 56,
        right: 56,
        flexDirection: "row",
        justifyContent: "space-between",
        fontSize: 9,
        color: HINT,
    },
    // v2 cover logo (dark wordmark on the white cover; 666x303 source).
    coverLogo: {
        width: 120,
        height: 55,
        objectFit: "contain",
        marginBottom: 28,
    },
    // Recommended Experts rows (v2): circular headshot (or initials
    // fallback) beside the pick's name/why-fits copy.
    expertRow: {
        flexDirection: "row",
        alignItems: "flex-start",
        marginBottom: 12,
    },
    expertAvatar: {
        width: 44,
        height: 44,
        borderRadius: 22,
        marginRight: 12,
        objectFit: "cover",
    },
    expertInitials: {
        width: 44,
        height: 44,
        borderRadius: 22,
        marginRight: 12,
        backgroundColor: "#FAF5ED",
        alignItems: "center",
        justifyContent: "center",
    },
    expertInitialsText: {
        fontFamily: "Lato-Bold",
        fontSize: 14,
        color: GOLD,
    },
    expertBody: {
        flex: 1,
    },
});
